import React from 'react';
import { Box, Text, TextButton, Tooltip } from '@wix/design-system';
import { StatusAlert, InfoCircle } from '@wix/wix-ui-icons-common';
import { FormattedMessage } from 'react-intl';
export const TooltipContent = _ref => {
  let {
    storageStatus,
    upgradeUrl,
    learnMoreUrl,
    onUpgradeButtonClick,
    onLearnMoreButtonClick,
    remainingStorage,
    gracePeriodDaysLeft
  } = _ref;
  const tooltipContent = (() => {
    const upgradeLink = function () {
      for (var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++) {
        chunks[_key] = arguments[_key];
      }
      return /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        skin: "light",
        size: "tiny",
        underline: "always",
        href: upgradeUrl,
        target: "_blank",
        dataHook: "upgrade-button-tooltip",
        onClick: () => onUpgradeButtonClick == null ? void 0 : onUpgradeButtonClick({
          fromTooltip: true
        })
      }, chunks);
    };
    switch (storageStatus) {
      case 'storageStatusUnlimited':
        {
          return /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "Storage.Media_Premium_Side_Panel_Tooltip"
          });
        }
      case 'storageStatusStandard':
        return upgradeUrl ? /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "Storage.Media_Side_Panel_Remaining_Tooltip",
          values: {
            remaining: remainingStorage,
            cta: upgradeLink
          }
        }) : /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "Storage.Media_Side_Panel_Remaining_Tooltip_NoUpgrade",
          values: {
            remaining: remainingStorage
          }
        });
      case 'storageStatusWarning':
        return upgradeUrl ? /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "Storage.Media_Side_Panel_Almost_Out_Tooltip",
          values: {
            remaining: remainingStorage,
            cta: upgradeLink
          }
        }) : /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "Storage.Media_Side_Panel_Almost_Out_Tooltip_NoUpgrade",
          values: {
            remaining: remainingStorage
          }
        });
      case 'storageStatusFull':
        // eslint-disable-next-line no-lone-blocks
        {
          if (!upgradeUrl) {
            const learnMoreLink = function () {
              for (var _len2 = arguments.length, chunks = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                chunks[_key2] = arguments[_key2];
              }
              return /*#__PURE__*/React.createElement(TextButton, {
                as: "a",
                href: learnMoreUrl,
                target: "_blank",
                size: "tiny",
                skin: "light",
                underline: "always",
                showTooltip: true,
                dataHook: "learn-more-button",
                onClick: onLearnMoreButtonClick
              }, chunks);
            };
            return gracePeriodDaysLeft ? /*#__PURE__*/React.createElement(FormattedMessage, {
              id: "Storage.Media_Side_Panel_Countdown_Tooltip_NoUpgrade",
              values: {
                countdown: gracePeriodDaysLeft,
                cta: learnMoreLink
              }
            }) : /*#__PURE__*/React.createElement(FormattedMessage, {
              id: "Storage.Media_Side_Panel_Tooltip_NoUpgrade",
              values: {
                cta: learnMoreLink
              }
            });
          }
        }
        return gracePeriodDaysLeft ? /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "Storage.Media_Side_Panel_Countdown_Tooltip",
          values: {
            countdown: gracePeriodDaysLeft,
            cta: upgradeLink
          }
        }) : /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "Storage.Media_Side_Panel_Tooltip_Storage_Full",
          values: {
            cta: upgradeLink
          }
        });
      default:
        return undefined;
    }
  })();
  return tooltipContent ? /*#__PURE__*/React.createElement(Box, {
    inline: true,
    height: "18px"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    textAlign: "start",
    maxWidth: "307px",
    dataHook: "storage-quota-tooltip",
    content: /*#__PURE__*/React.createElement(Text, {
      light: true,
      size: "tiny"
    }, tooltipContent)
  }, /*#__PURE__*/React.createElement(TextButton, null, storageStatus === 'storageStatusFull' ? /*#__PURE__*/React.createElement(StatusAlert, {
    style: {
      fill: '#D0180B'
    },
    size: "18px"
  }) : /*#__PURE__*/React.createElement(InfoCircle, {
    style: {
      fill: '#868AA5'
    },
    size: "18px"
  })))) : null;
};
//# sourceMappingURL=TooltipContent.js.map